import c from "../common";

export default {
  //header
  Back: c.Back.chn,
  ChangeData: "修改商戶資料",
  ReasonModify: "需要修改原因 或 內容",

  //
  Approved: c.approved.chn,
  NeedEdit: "需要修改並重交",

  //Card Showing status
  StatusTitle: "審核情況",
  Number: "申請編號",
  AppliedOn: "提出申請時間",
  LastModify: "最後修改時間",
  ApprovedOn: "批准時間",
  Progress: "進度",

  //Status
  Processing: "審核中",
  Approved: "已批核",
  NeedModify2: "需要修改,並重新提交",
  Reject: "已拒絕",

  //BR
  RelatedDoc: "相關文件",
  businessNumber: "商業登記號",
  BR: "商業登記證(BR)",
  Download: c.download.chn,

  //Detail Card - processing merchant
  Address: "分店地址",
  ShowAllAdd: "顯示全部地點",
  OpeningHour: "營業時間",
  intro: c.intro.chn,
  VendorData: "商店資料",
  Vendor: "申請商店",

  success: "成功",
  updateInfo: "更改資料",
  addTotalQty: "增加劵數量",
  Cancelled: c.Cancelled.chn,
  
  
  description_1: "新增拒絕原因 (如有)",
  description_2: "確定拒絕",
  description_3: "如沒有, 可留空",


  description_4: "商店尚未審批",
  description_5: "商店己是夥伴",
  description_6: "發生錯誤: ",
  description_7: "夥伴不存在",
  description_8: "標記為不屬於本公司",
  description_9: "標記為屬於本公司",
  description_10: "移除夥伴",
  description_11: "新增夥伴",
  description_12: "此店屬於本公司",
  description_13: "不屬於本公司",
  description_14: "商店ID",
  description_15: "夥伴",
  description_16: "增加",
  description_17: "屬於本公司",
  description_18: "無",
};
